import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderComponent} from '../landing/header/header.component';
import {StorageService} from '../shared/services/storage.service';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../shared/services/auth.service';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {AlertService} from '../shared/services/alert.service';
import {ProfileService} from '../shared/services/profile-service';
import {FileService} from '../shared/services/file.service';
import {GlobalService} from '../shared/services/global.service';
import {UploadService} from '../shared/services/upload.service';
import {ImageCropperComponent} from 'ngx-image-cropper';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {MatIcon} from "@angular/material/icon";
import {AppConstants} from "../shared/constants/app-constant";
import {CountryService} from "../shared/services/country.service";
import {StateService} from "../shared/services/state.service";
import {ProfileImageService} from '../shared/services/profile-image.service';
import {SharedModule} from "../shared/shared.module";
import {VexScrollbarComponent} from "@vex/components/vex-scrollbar/vex-scrollbar.component";

@Component({
  selector: 'vex-getting-started',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    NgClass,
    HeaderComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    ReactiveFormsModule,
    NgStyle,
    MatTooltipModule,
    MatCheckboxModule,
    ImageCropperComponent,
    MatIcon,
    SharedModule,
    VexScrollbarComponent
  ],
  templateUrl: './getting-started.html',
  styleUrl: './getting-started.scss',
  providers: [StorageService, AuthService, ProfileService, FileService, GlobalService, UploadService, CountryService, StateService],
})
export class GettingStarted implements OnInit {
  profileImageForm: FormGroup = new FormGroup({});
  billingForm: FormGroup = new FormGroup({});
  currentIndex: number = 0;
  buttonText: string = 'Next';
  defaultCountry: any = AppConstants.DEFAULT_COUNTRY;
  countries: any;
  states: any
  user: any;
  content: any[] =
    [
      {
        heading: 'Welcome to ORBIT – Your All-in-One Office Management ERP System',
        image: '/assets/images/getting-started-img/welcome-to-orbit.webp'
      },
      {
        heading: 'Manage office operations effortlessly from a Unified Platform; automate repetitive tasks and enhance workflow.',
        image: '/assets/images/getting-started-img/manage-office-operations-effortlessly.gif'
      },
      {
        heading: 'Save Time, Cost, and Efforts by Reducing Manual Dependency and Improving Accuracy.',
        image: '/assets/images/getting-started-img/save-time-cost-and-efforts.gif'
      },
      {
        heading: 'Collaborate better with teams & departments through integrated communication tools.',
        image: '/assets/images/getting-started-img/collaborate-better-with-teams.gif'
      },
      {
        heading: 'ORBIT – Empowering organizations with advanced technology following real-time reports and analytics.',
        image:
          '/assets/images/getting-started-img/orbit-empowering-organizations-with-advanced-technology.gif',
      },
      {
        heading: 'Upload your profile picture',
        image: ''
      },
      {
        heading: 'Add your billing address',
        image: ''
      },
      {
        heading: 'Description video',
        // image: ''
      }
    ];

  defaultProfileIcons: any[] = [];
  imageChangedEvent = null;
  croppedImage = null;
  previewImage = null;
  userProfileImage: any;
  btnActive: any = false;
  indianStateError: any = false;
  foreignStateError: any = false;
  pageExtras: any = {
    'submitted': false,
    'buttonText': 'Next',
    'currentIndex': 0,
    'selectedCountry': false,
    'buttonStatus': true
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    protected dialog: MatDialog,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private alertService: AlertService,
    private profileService: ProfileService,
    private fileUploadService: FileService,
    private countryService: CountryService,
    private stateService: StateService,
    private cd: ChangeDetectorRef,
    private imageService: ProfileImageService
  ) {
    this.authService.self().subscribe(data => {
      if (data && data.id) {
        this.user = data;
        this.route.data.subscribe(data => {
          if (!data.availableTo.includes(this.user.user_type)) {
            this.router.navigateByUrl('/');
            return;
          } else {
            this.billingForm.patchValue({
              country_id: (this.user && this.user.country_id) ? this.user.country_id : '',
              foreign_state_name: (this.user && this.user.foreign_state_name) ? this.user.foreign_state_name : '',
              city: (this.user && this.user.city) ? this.user.city : '',
              zip_code: (this.user && this.user.zip_code) ? this.user.zip_code : '',
              address: (this.user && this.user.address) ? this.user.address : '',
              gst_number: (this.user && this.user.gst_number) ? this.user.gst_number : '',
              pan_number: (this.user && this.user.pan_number) ? this.user.pan_number : '',
            });
            if (this.user.country_id == this.defaultCountry.id) {
              this.getStates(this.user.country_id.toString());
            }
          }
        });
      } else {
        this.router.navigateByUrl('/');
      }
    });

  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.profileImageForm = this.formBuilder.group({
      profile_img: ['', Validators.required]
    });
    this.billingForm = this.formBuilder.group({
      gst_number: ['', Validators.required],
      pan_number: ['', Validators.required],
      address: ['', Validators.required],
      country_id: ['', Validators.required],
      state_id: [''],
      foreign_state_name: [''],
      city: ['', Validators.required],
      zip_code: ['', Validators.required],
      acknowledge: [false]
    });
  }

  previous(): void {
    if (this.pageExtras['currentIndex'] > 0) {
      this.pageExtras['currentIndex']--;
      if (this.pageExtras['currentIndex'] === 5) {
        this.pageExtras['buttonText'] = 'Save & Next';
      } else if (this.pageExtras['currentIndex'] === 6) {
        this.pageExtras['buttonText'] = 'Save & Next';
      } else if (this.pageExtras['currentIndex'] === 7) {
        this.pageExtras['buttonText'] = 'Go to dashboard';
      } else {
        this.pageExtras['buttonText'] = 'Next';
      }
    }
  }

  next(): void {
    if (this.pageExtras['currentIndex'] === this.content.length - 1) {
      this.dialog.closeAll();
    }
    if (this.pageExtras['currentIndex'] === 4) {
      if (!this.user.profile_image) {
        this.btnActive = true;
      }
      this.getIcons();
      this.pageExtras['buttonText'] = 'Save & Next';
      this.pageExtras['currentIndex']++;
    } else if (this.pageExtras['currentIndex'] === 5) {
      this.getCountries();
      this.pageExtras['buttonText'] = 'Save & Next';
      this.pageExtras['currentIndex']++;
    } else if (this.pageExtras['currentIndex'] === 6) {
      this.updateBillingInformation();
    } else if (this.pageExtras['currentIndex'] === 7) {
      this.updateGateStarted();
    } else {
      this.pageExtras['buttonText'] = 'Next';
      this.pageExtras['currentIndex']++;
    }
  }

  getCountries(): void {
    this.countryService.get().subscribe(data => {
      if (data && data['data'].length > 0) {
        this.countries = data['data'];
      }
    });
  }

  getStates(country: any): void {
    this.pageExtras.selectedCountry = country;
    if (country == AppConstants.DEFAULT_COUNTRY.id) {
      this.stateService.get().subscribe(data => {
        if (data && data['data'].length > 0) {
          this.states = data['data'];
        }
        if (this.user.country_id == AppConstants.DEFAULT_COUNTRY.id) {
          this.billingForm.patchValue({
            state_id: this.user.state_id
          });
        }
      });
    }
  }

  getIcons(): void {
    this.profileService.getIcons().subscribe(data => {
      if (data && data['data'].length > 0) {
        this.defaultProfileIcons = data['data'].map((item: any) => item.image_url);
      }
    });
  }

  updateBillingInformation(): void {
    this.pageExtras['submitted'] = true;
    this.indianStateError = false;
    this.foreignStateError = false;
    if (this.pageExtras['currentIndex'] === 6) {
      const params: {} = {
        gst_number: (this.billingForm.value && this.billingForm.value.gst_number) ? this.billingForm.value.gst_number : '',
        pan_number: (this.billingForm.value && this.billingForm.value.pan_number) ? this.billingForm.value.pan_number : '',
        address: (this.billingForm.value && this.billingForm.value.address) ? this.billingForm.value.address : '',
        acknowledge: (this.billingForm.value && this.billingForm.value.acknowledge) ? this.billingForm.value.acknowledge : '',
        zip_code: (this.billingForm.value && this.billingForm.value.zip_code) ? this.billingForm.value.zip_code : '',
        city: (this.billingForm.value && this.billingForm.value.city) ? this.billingForm.value.city : '',
        country_id: (this.billingForm.value && this.billingForm.value.country_id) ? this.billingForm.value.country_id : '',
        state_id: (this.billingForm.value && this.billingForm.value.state_id) ? this.billingForm.value.state_id : '',
        foreign_state_name: (this.billingForm.value && this.billingForm.value.foreign_state_name) ? this.billingForm.value.foreign_state_name : '',
      }
      if (params && (parseInt(params['country_id']) === parseInt(AppConstants.DEFAULT_COUNTRY['id']))) {
        if (params && params['state_id'] === '') {
          this.foreignStateError = false;
          this.indianStateError = true;
          return;
        }
      } else if (params && (parseInt(params['country_id']) !== parseInt(AppConstants.DEFAULT_COUNTRY['id']))) {
        if (params && params['foreign_state_name'] === '') {
          this.indianStateError = false;
          this.foreignStateError = true;
          return;
        }
      }
      this.authService.billingInformation(params).subscribe(data => {
        this.pageExtras['buttonText'] = 'Go To Dashboard';
        this.pageExtras['currentIndex']++;
        this.pageExtras['submitted'] = false;
        this.indianStateError = false;
        this.foreignStateError = false;
        this.billingForm.patchValue({
          country_id: params['country_id'],
          foreign_state_name: params['foreign_state_name'],
          city: params['city'],
          zip_code: params['zip_code'],
          address: params['address'],
          gst_number: params['gst_number'],
          pan_number: params['pan_number'],
        });
        if (this.user.country_id == this.defaultCountry.id) {
          this.getStates(this.user.country_id.toString());
        }
      }, error => {
        this.pageExtras['submitted'] = false;
        this.indianStateError = false;
        this.foreignStateError = false;
      });
    }
  }

  updateGateStarted(): void {
    this.authService.getStartedUpdate().subscribe(data => {
      this.dialog.closeAll();
    });
  }

  selectDefaultIcon(icon: any): void {
    const params: {} = {
      'type': 'ICON',
      'file': icon
    };
    this.fileUploadService.updateProfileLogo(params).subscribe(data => {
        if (data && data.id) {
          this.uploadProfileImage(data);
        }
      }
    );
  }

  async fileChangeEvent(): Promise<void> {
    if (this.croppedImage) {
      const params: {} = {
        'type': 'PROFILE_IMAGE',
        'fileType': 'BASE64',
      };
      this.fileUploadService.singleFileUpload(params, this.croppedImage).subscribe(data => {
        this.uploadProfileImage(data['data']);
      });
    } else {
      this.alertService.showErrors('File size is too large');
    }
  }

  uploadProfileImage(data: any): void {
    const params: {} = {
      profile_image: data.id
    }
    this.authService.updateProfile(params).subscribe(response => {
      this.previewImage = data.url;
      this.imageChangedEvent = null;
      this.imageService.shareData(data.url);
      this.user.profile_image = data.url;
      this.cd.detectChanges();
      this.btnActive = false;
    });
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files.length) {
      const file = event.dataTransfer.files[0];
      this.previewFile(file);
    }
  }

  previewFile(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.previewImage = reader.result;
    };
    reader.readAsDataURL(file);
  }

  getImage(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent): void {
    if ((event.blob.size / 8388608) <= 2) {
      this.previewImage = event.objectUrl;
      this.convertBlobToBase64(event.blob);
    }
  }

  convertBlobToBase64(blob: Blob): void {
    const reader = new FileReader();
    reader.onloadend = () => {
      this.croppedImage = reader.result as string;
    };
    reader.readAsDataURL(blob);
  }

  imageLoaded(): void {
  }

  cropperReady(): void {
  }

  loadImageFailed(): void {
  }

  saveProfileImage(): void {
    this.userProfileImage = this.croppedImage;
  }
}

